export const cars =[
    {
        image: "/images/Toyota_Fortuner/1.jpg",
        // title: "Toyota Fortuner"
    },
    {
        image: "/images/Toyota_Fortuner/2.jpg",
        // title: "Toyota Fortuner"
    },
    {
        image: "/images/Toyota_Fortuner/3.jpg",
        // title: "Toyota Fortuner"
    },
    {
        image: "/images/Toyota_Fortuner/4.jpg",
        // title: "Toyota Fortuner"
    },
    {
        image: "/images/Toyota_Fortuner/5.jpg",
        // title: "Toyota Fortuner"
    }
];